export const SECONDS_PER_MINUTE: number = 60;
export const MINUTES_PER_HOUR: number = 60;
export const SECONDS_PER_HOUR: number = SECONDS_PER_MINUTE * 60;
export const HOURS_PER_DAY: number = 24;
export const SECONDS_PER_DAY: number = SECONDS_PER_HOUR * 24;